export default {"src":"/_next/static/media/cart-icon-dark-empty.2d6bad3c.svg","height":23,"width":26};